const getters = {
  getUserInfo: state => state.userInfo,
  getUserId: state => state.userId
}

export default getters
